import * as React from 'react';
import { ControlFacet } from '../models/controls/ControlFacet';
import { IWithWizardInjectedProps } from '../components/decorators/withWizard';

export type ICreateFolderWizardProps = IWithWizardInjectedProps & {
  onCreateFolder: (props: { name: string }) => Promise<void>;
  itemKey: string;
  isAvailable: boolean;
  validator?: (folderName: string) => string | undefined;
  title?: string;
  maxLength: number | undefined;
};
export const createFolderActionControl = new ControlFacet<{
  itemKey: string;
}, {
  isAvailable: boolean;
  validator: (folderName: string) => string | undefined;
  maxLength: number | undefined;
  title?: string;
  createFolderWizard: React.ComponentType<ICreateFolderWizardProps>;
}>('createFolderActionControl');
